import { render } from "./UserManagementPanel.vue?vue&type=template&id=90fe54a6"
import script from "./UserManagementPanel.vue?vue&type=script&lang=js"
export * from "./UserManagementPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__